import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import LangContext, { Lang } from 'context/LangContext'
import MessageContext from 'context/MessageContext'
import NotificationsIcon from '@mui/icons-material/Notifications'
import {
  Header as AppBar,
  Badge,
  ComboBox,
  ComboBoxDefaultOption,
  Hidden,
  IconButton,
  Stack,
  Tab,
  Tabs,
  Toggle,
  Typography,
} from '@airbus/components-react/components'
import ModalUserMenu from './components/modalUserMenu'
import NavBar, { getFirstTwoSegments, getMenuItems } from 'components/navBar'
import LightDarkContext from 'context/LightDarkModeContext'
import AuthContext from 'context/AuthContext'
import ComponentsUNames from 'constants/componentsUNames'
import LocalStorage from 'utils/myLocalStorage'

const TabMenu = () => {
  const location = useLocation()
  const navigate = useNavigate()

  return (
    <Tabs value={getFirstTwoSegments(location.pathname)}>
      {getMenuItems().map(
        ({ path, label, display }) =>
          display && (
            <Tab key={path} value={path} onClick={() => navigate(path)}>
              {label}
            </Tab>
          ),
      )}
    </Tabs>
  )
}

const Header = () => {
  const baseUrl = process.env.PUBLIC_URL
  const appName = process.env.REACT_APP_NAME

  const [isOpened, setOpened] = useState(false)
  const { handleToggleModalMessages, allDisplayedMessages } = useContext(MessageContext)
  const { lang, handleSwitchLanguage } = useContext(LangContext)
  const { mode, setMode } = useContext(LightDarkContext)
  const { isConnected } = useContext(AuthContext)

  const { t } = useTranslation()

  const languages_short = [
    { value: 'fr', label: t('9500006') },
    { value: 'en', label: t('9500007') },
  ]

  const switchLanguageHandler = (val: ComboBoxDefaultOption) => {
    handleSwitchLanguage(val.value as Lang)
  }

  const switchThemeHandler = (modeDark: boolean) => {
    const modeName = modeDark ? 'dark' : 'light'
    LocalStorage.put(
      [LocalStorage.KEY_PREFS, ComponentsUNames.USERPREFS_STORE_NAME, ComponentsUNames.USERPREFS_THEME],
      modeName,
    )
    setMode(modeName)
  }

  useEffect(() => {
    // Update tab-name based on selected language
    document.title = appName + ' - ' + eval('CONFIGAPP__ENV_TITLE')[lang]
  }, [lang])

  const handleToggleMenu = () => {
    setOpened(!isOpened)
  }

  const navigate = useNavigate()

  const MenuActions = (
    <>
      <ComboBox
        value={lang}
        onChange={switchLanguageHandler}
        options={languages_short.map(({ label, value }) => ({
          label,
          value,
        }))}
        hideClear
        style={{ width: '80px' }}
      />
      <Stack align='center'>
        <Typography variant='small'>{t(mode)}</Typography>
        <Toggle checked={mode === 'dark'} onChange={(e) => switchThemeHandler(e.target.checked)} />
      </Stack>
      <IconButton variant='ghost' onClick={() => handleToggleModalMessages()} size='large'>
        {allDisplayedMessages?.length > 0 ? (
          <>
            <Badge count={allDisplayedMessages?.length} variant='info'>
              <NotificationsIcon />
            </Badge>
          </>
        ) : (
          <>
            <NotificationsIcon />
          </>
        )}
      </IconButton>
    </>
  )

  return (
    <>
      <Hidden down='xl'>
        <AppBar onHomeClick={() => baseUrl && navigate(baseUrl)} appName={eval('CONFIGAPP__ENV_TITLE')[lang]}>
          <TabMenu />
          {isConnected && MenuActions}
          <ModalUserMenu />
        </AppBar>
      </Hidden>
      <Hidden on={['xxs', 'xs', 'xl', 'xxl']}>
        <AppBar
          showMenuButton
          onMenuButtonClick={handleToggleMenu}
          onHomeClick={() => baseUrl && navigate(baseUrl)}
          appName={eval('CONFIGAPP__ENV_TITLE')[lang]}
        >
          <NavBar onToggleMenu={handleToggleMenu} isOpened={isOpened} />
          {isConnected && MenuActions}
          <ModalUserMenu />
        </AppBar>
      </Hidden>
      <Hidden up='sm'>
        <AppBar showMenuButton onMenuButtonClick={handleToggleMenu} onHomeClick={() => baseUrl && navigate(baseUrl)}>
          <NavBar onToggleMenu={handleToggleMenu} isOpened={isOpened} />
          {isConnected && MenuActions}
          <ModalUserMenu />
        </AppBar>
      </Hidden>
    </>
  )
}

export default Header
